module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "normal_1"
  }, [_c('i', [_vm._v("I am really sorry you’re unhappy right now. I have a hard time believing the only reason for this is my inability to keep the house exactly the way you like it.… We usually have so much fun together. We have so much to be happy and thankful for")]), _vm._v(" … "), _c('i', [_vm._v("It really upsets me when I hear you talk about divorce … Things have been so good for us for so long, you don’t just wake up one day and suddenly decide something like that")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('span', [_c('i', [_vm._v("All my love")]), _vm._v(",")])]), _vm._v(" "), _c('p', {
    staticClass: "right1"
  }, [_c('span', [_c('i', [_vm._v("Irene")])])]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('span', [_vm._v("—from the Warrant for the Arrest of")])]), _vm._v(" "), _c('p', {
    staticClass: "right2"
  }, [_c('span', [_vm._v("Jack Kenneth Barron")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8513a9ea","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/fm_01.vue
// module id = 69
// module chunks = 0